export default "__VITE_ASSET__Dldc3cRS__"